import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	removeCondition: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.conditions.condition.fields.selected-condition.remove-condition',
		defaultMessage: 'Remove condition',
		description: 'Text message for remove condition',
	},
	validateMessage: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.conditions.condition.fields.selected-condition.validate-message',
		defaultMessage: 'Please select at least one condition',
		description: 'Error message to add at least one condition',
	},
});
